module.exports = __webpack_public_path__ + "img/High-efficiency network.8261439d.svg";